import { Tabs } from "antd";
import { useEffect } from "react";
import { PaymentCodSetting } from "./components/payment-cod-setting";
import { PaymentTransferSetting } from "./components/payment-transfer-setting";

export function PaymentSettingPage() {
  useEffect(() => {
    document.title = "Cấu hình thanh toán";
  }, []);

  return (
    <>
      <Tabs type="card">
        <Tabs.TabPane tab="Thanh toán COD" key="cod">
          <PaymentCodSetting />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Thanh toán chuyển khoản" key="chuyen-khoan">
          <PaymentTransferSetting />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Thanh toán online" key="online">
          Đang cập nhật
        </Tabs.TabPane>
      </Tabs>
    </>
  );
}
